import React from "react";
import { useController } from "react-hook-form";
import { FormHelper } from "../_helpers/FormHelper";
import MCSFileUpload from "./MCSFileUpload";

function MCSControlFileUpload(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    field.onChange(e);
    props.handleChange(e);
  };
  return (
    <MCSFileUpload
      fileName={props.fileName}
      accept={props.accept}
      invalid={fieldState.invalid}
      showErrorText={fieldState.invalid}
      errorText={FormHelper.renderErrorMsg(fieldState.error)}
      onChange={handleChange}
    />
  );
}

export default MCSControlFileUpload;
